const CommunicationsTab = () => {
  return (
    <div className="gestiones-tab-content gestiones-placeholder">
      <p>Próximamente podrá consultar las comunicaciones de su empresa.</p>
    </div>
  );
};

export default CommunicationsTab;
